import SourceSelection from "@/components/ai-training/source-selection/source-selection";
import { Button } from "@/components/ui/button";
import useUpdateQueryParams from "@/hooks/use-update-query-params";

// import SourceSelection from "../../ai-training/source-selection/source-selection";

const Step2 = () => {
    const updateSearchParams = useUpdateQueryParams();
    const handleSkip = () => {
        updateSearchParams({ step: "3" });
    };
    return (
        <div>
            <SourceSelection />
            <div className="mt-6 flex justify-end gap-4">
                <Button variant={"default"} onClick={handleSkip}>
                    Proceed to Step 3
                </Button>
            </div>
        </div>
    );
};

export default Step2;
